const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5363ddc25ce27df1c8f964611b7f45b50c7f3a11"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"5363ddc25ce27df1c8f964611b7f45b50c7f3a11"};
      